import { Get } from "@/axios/AxiosFunctions";
import PopperComponent from "@/components/Core/PopperComponent";
import SearchInput from "@/components/Core/SearchInput";
import SideBarSkeleton from "@/components/Core/SideBarSkeleton";
import TableStructure from "@/components/Core/TableStructure";
import { BaseURL } from "@/config/apiUrl";
import { recordsLimit } from "@/constant/constants";
import useDebounce from "@/customHooks/useDebounce";
import { requestEditsHeaders } from "@/data/data";
import {
  formatDateTime,
  getId,
} from "@/helper/HelperFunction";
import { useEffect, useState } from "react";
import { FaRegEye } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classes from "./RequestEdits.module.css";

const API_URLS = {
  GET_ALL: BaseURL("admin/posts/find-edits/all"),
};

const LOADING_ACTIONS = {
  GET_ALL: "getAll",
};

const RequestEdits = () => {
  const navigate = useNavigate();
  const { access_token: accessToken } = useSelector(
    (state) => state.authReducer
  );
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [totalRecord, setTotalRecord] = useState(0);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(null);

  const handlePopperAction = (action, item) => {
    if (!action || !action.value) return;
    switch (action.value) {
      case "view":
        navigate(`/request-edits/${item?.post}`);
        break;
      default:
        console.warn(`Unknown action: ${action.value}`);
    }
  };
  const debounceSearch = useDebounce(search, 500);
  // get all request edits
  const getRequestEdits = async (_page = page) => {
    const queryParams = {
      page: _page,
      limit: recordsLimit || 10,
      search: debounceSearch || "",
    };
    setIsLoading(LOADING_ACTIONS.GET_ALL);
    const response = await Get(
      `${API_URLS.GET_ALL}?${new URLSearchParams(queryParams).toString()}`,
      accessToken
    );
    if (response?.data) {
      setTotalRecord(response.data.totalCount || 0);
      setData(response.data.posts || []);
    }
    setIsLoading(null);
  };

  useEffect(() => {
    setPage(1);
    getRequestEdits(1);
  }, [debounceSearch]);
  return (
    <SideBarSkeleton>
      <div className={classes.users}>
        <TableStructure
          headerTitle={
            <SearchInput
              value={search}
              setter={setSearch}
              placeholder="Search"
            />
          }
          tableContent={data?.map((item) => ({
            ...item,
            postId: getId(item?._id) || "-",
            pendingEdits: item?.pendingEdits?.length || 0,
            acceptedEdits: item?.acceptedEdits?.length || 0,
            rejectedEdits: item?.rejectedEdits?.length || 0,
            latestEdit: formatDateTime(item?.latestEdit),
            actions: (
              <PopperComponent
                data={getPopperOptions(item)}
                handleClick={(action) => handlePopperAction(action, item)}
              />
            ),
          }))}
          tableHeaders={requestEditsHeaders}
          tableType="secondary"
          page={page}
          setPage={(page) => {
            setPage(page);
            getRequestEdits(page);
          }}
          isLoading={isLoading === LOADING_ACTIONS.GET_ALL}
          totalRecord={totalRecord}
          recordLimit={recordsLimit}
          noDataMessage="No request edits found"
          showPagination={true}
          customStyle={{
            height: "calc(100vh - 320px)",
          }}
        />
      </div>
    </SideBarSkeleton>
  );
};

export default RequestEdits;

const getPopperOptions = (item) => {
  const options = [{ icon: <FaRegEye />, label: "View", value: "view" }];
  return options;
};
